// Exam guide and landing content. Facts are carried over from the legacy site without change:
//   assets/js/exam-guide.js (subjects :7-12, papers/counts :63-64, dates :66, FAQ :67-68, Jiangxi summary :20-36)
//   assets/js/landing-data.js (SUBJECTS :9-14, FLOW :61-66)
//   assets/desktop-ui/brand-home.js (home FAQ :30, dates :29)
//   assets/js/app.js:13245-13247 (default exam date 2026-11-21)
//   contact/index.html (contact channels)

export const EXAM_YEAR = 2026
/** Official national written exam date (assets/js/app.js:13246 OFFICIAL_EXAM_DATE). */
export const EXAM_DATE = '2026-11-21'

export interface Subject {
  code: string
  name: string
  short: string
  summary: string
  paper: 1 | 2
  /** Landing card text (assets/js/landing-data.js SUBJECTS). */
  card: string
}

export const SUBJECTS: Subject[] = [
  {
    code: '科一', name: '政策与法律法规', short: '政策法规', paper: 1,
    summary: '从旅游法律关系、导游人员管理到旅游安全与应急，理解规则及其适用情境。',
    card: '旅游权利义务、合同、安全与法律责任，理解行业规则。',
  },
  {
    code: '科二', name: '导游业务', short: '导游业务', paper: 1,
    summary: '围绕接待流程、服务规范、讲解技能和突发应变，建立完整的导游业务框架。',
    card: '带团流程、服务规范、讲解技能与突发应变，训练现场操作能力。',
  },
  {
    code: '科三', name: '全国导游基础知识', short: '全国基础', paper: 2,
    summary: '从历史、地理到建筑园林、民族宗教与饮食文化，把全国通识串成清晰的知识结构。',
    card: '中国历史、文化、建筑、园林、饮食、宗教与民族，搭建全国通识框架。',
  },
  {
    code: '科四', name: '地方导游基础知识', short: '地方基础', paper: 2,
    summary: '学习全国各省区市的地域概况、代表景观、物产与文化。笔试范围包含全国地方知识。',
    card: '各省区的景观、物产、线路与区域文化，把知识挂回地理空间。',
  },
]

export interface Paper {
  label: string
  subjects: string[]
  rule: string
}

export const PAPERS: Paper[] = [
  { label: '第一张合卷', subjects: ['科一 政策与法律法规', '科二 导游业务'], rule: '各占 50% · 90 分钟 · 100 分' },
  { label: '第二张合卷', subjects: ['科三 全国导游基础知识', '科四 地方导游基础知识'], rule: '各占 50% · 90 分钟 · 100 分' },
]

export interface CountItem { count: number; type: string; score: string }

export const COUNTS: CountItem[] = [
  { count: 40, type: '判断题', score: '0.5 分 / 题，共 20 分' },
  { count: 90, type: '单项选择题', score: '0.5 分 / 题，共 45 分' },
  { count: 35, type: '多项选择题', score: '1 分 / 题，共 35 分' },
]

export const COUNT_NOTES = {
  perPaper: '每卷 165 题 · 100 分 · 90 分钟',
  total: '两卷合计 330 题 · 200 分 · 180 分钟，不含科目五。',
  perSubject: '每科 50 分，占所在合卷 50%，占笔试两卷总分 25%。官方没有单列每科固定题量，不能把合卷题数平均分给两科。',
  source: '依据：文化和旅游部 2026 笔试大纲第 2 页',
}

export const SUBJECT_FIVE = {
  title: '科目五 导游服务能力',
  text: '现场考试，按报考地区准备。各省级文化和旅游行政部门分别发布现场考试大纲，景点范围、考试方式和评分要求以报考地官方文件为准。',
}

export const ELIGIBILITY_NOTE = '普通考生参加四科机考与科目五现场考试；已取得资格证书、增加语种者，仅参加现场考试。'

export interface KeyDate { label: string; date: string; time: string }

// All times are Beijing time (assets/js/exam-guide.js:66).
export const KEY_DATES: KeyDate[] = [
  { label: '报名截止', date: '09.14', time: '17:00' },
  { label: '审核截止', date: '09.18', time: '17:00' },
  { label: '交费截止', date: '09.24', time: '17:00' },
  { label: '准考证开放', date: '11.16', time: '09:00 起' },
  { label: '全国笔试', date: '11.21', time: '两张合卷各 90 分钟' },
  { label: '成绩查询', date: '2027.03.01', time: '09:00 起' },
]

export const DATES_NOTE = '以上均为北京时间；各地面试时间以当地公告与准考证为准。'

export interface FaqItem { q: string; a: string }

// Exam guide FAQ (assets/js/exam-guide.js:67-68).
export const GUIDE_FAQ: FaqItem[] = [
  {
    q: '我能报考吗？',
    a: '基本条件包括中国公民、高中或中专及以上学历、健康状况，以及适应导游工作需要的基本知识和表达能力。港澳台居民、2027 届中职旅游类毕业生请另阅官方对应条款。',
  },
  {
    q: '需要准备哪些报名材料？',
    a: '按报名系统要求上传证件、学历及照片等材料，再办理审核与交费。具体格式和补充材料以当年报名系统及考区通知为准。',
  },
  {
    q: '笔试、面试和成绩有效期怎么理解？',
    a: '普通考生需要参加笔试与现场考试，按当年通知的划线要求确定是否合格。考试成绩当年有效，不跨年保留。',
  },
  {
    q: '增加语种要重新考四科吗？',
    a: '已取得导游资格证书、需要增加语种者，仅参加现场考试；按报考地区的外语面试大纲准备讲解、问答与口译要求。',
  },
  {
    q: '每科各有多少题、占多少分？',
    a: '每张合卷 165 题、100 分，两个科目各占 50% 分值。官方没有规定每科固定题数，不能把 165 题平均分开。每卷含判断 40 题、单选 90 题、多选 35 题。',
  },
]

// Landing page FAQ (assets/desktop-ui/brand-home.js:30).
export const LANDING_FAQ: FaqItem[] = [
  {
    q: '第一次准备，该从哪里开始？',
    a: '先阅读考试介绍与当年官方大纲，再进入笔试练习选择一科、一个章节。做完练习后查看解析，逐步整理需要复习的知识点。',
  },
  {
    q: '只学自己省份的地方知识就可以吗？',
    a: '科目四笔试学习全国地方导游基础知识；科目五现场考试按报考地区和语种要求准备，两者范围不同。',
  },
  GUIDE_FAQ[4]!,
  {
    q: '报考条件与材料，到哪里核对？',
    a: '请阅读文化和旅游部当年考试通知，再按官方报名系统与报考地区通知准备材料。',
  },
  {
    q: '手机、App 和小程序能用同一套学习内容吗？',
    a: '登录后可使用账号同步学习记录。当前设备可用的功能以实际页面为准。',
  },
]

export interface FlowStep { no: string; title: string; text: string }

// Learning loop (assets/js/landing-data.js FLOW).
export const FLOW: FlowStep[] = [
  { no: '01', title: '对齐大纲', text: '先确认年份、科目与章节边界，知道这次考试究竟要求什么。' },
  { no: '02', title: '建立理解', text: '用课程、地图和图解看清知识结构，不从孤立结论开始背。' },
  { no: '03', title: '用题验证', text: '完成对应章节练习，让答案与解析暴露真正薄弱的知识点。' },
  { no: '04', title: '间隔巩固', text: '错题在合适时间再次出现，用重复提取替代低效抄写与反复翻书。' },
]

export const CONTACT = {
  email: '873292521@qq.com',
  wechat: 'fc665xd',
  note: '内容纠错请附上科目、章节、完整题干和可核验来源，我们会先核实事实，再安排修订。工作日处理。',
}

// Jiangxi on-site exam summary, verified by the legacy site on 2026.09.06 (assets/js/exam-guide.js:20-36).
// Only Jiangxi has an in-site summary; other provinces link to the official source only.
export const JIANGXI_SUMMARY = {
  checked: '2026.09.06',
  intro: '通过机考录制讲解与答题音视频，随机抽取 1 个江西文化专题加 1 个景点。',
  flow: ['讲解：文化专题与景点', '问答：服务规范、应变能力、综合知识'],
  foreignNote: '外语考生还需准备中译外和外译中的口译要求。',
  topics: '文化专题包括江西陶瓷文化、书院文化、红色文化、茶文化、客家文化等。',
  spots: ['庐山风景名胜区', '井冈山风景名胜区', '三清山风景名胜区', '龙虎山风景名胜区', '景德镇古窑民俗博览区', '共和国摇篮旅游区', '大觉山景区', '明月山旅游区', '滕王阁旅游区', '萍乡武功山风景名胜区', '新余仙女湖'],
  scoring: '知识问答涵盖导游服务规范、导游应变能力与导游综合知识。中文、外语考生的时长、分值和口译要求分别列于官方大纲，请按语种查看原文。',
}
